import { usePrefetch } from "@/services/api";
import { useCallback } from "react";

export const usePrefetchCallbacks = () => {
  const prefetchSites = usePrefetch("apiV1AssessmentsSitesList");
  const prefetchUsers = usePrefetch("apiV1UserManagementList");
  const prefetchCorporations = usePrefetch("apiV1CorporationsList");
  const prefetchAssessments = usePrefetch("apiV1AssessmentsAssessmentsList");
  const prefetchReports = usePrefetch("apiV1AssessmentsSitesAssignedAssessmentsWithStandardsList");
  const prefetchCustomReports = usePrefetch("apiV1ReportsCustomList");

  const prefetchSitesCallback = useCallback(() => {
    prefetchSites({});
  }, []);

  const prefetchUsersCallback = useCallback(() => {
    prefetchUsers({ page: 1 });
  }, []);

  const prefetchCorporationsCallback = useCallback(() => {
    prefetchCorporations();
  }, []);

  const prefetchAssessmentsCallback = useCallback(() => {
    prefetchAssessments({ active: true });
  }, []);

  const prefetchReportsCallback = useCallback(() => {
    prefetchReports({});
    prefetchCustomReports({});
  }, []);

  return {
    prefetchSitesCallback,
    prefetchUsersCallback,
    prefetchCorporationsCallback,
    prefetchAssessmentsCallback,
    prefetchReportsCallback,
  };
};
